import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import VSelect from 'vue-select';

// Types

// Composables
import { useLocalization } from '~/composables/_next/useLocalization';
import { useLocaleSwitcher } from '~/composables/_next/useLocaleSwitcher';

// Misc
import { gtmPushEvent } from '~/helpers/gtm';

// Components
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import LocaleIcon from '~/components/_next/atoms/AzFlagIcon.vue';
import InformationBox from '~/components/Molecules/InformationBox.vue';
import InformationItem from '~/components/Molecules/InformationItem.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { AZ_COUNTRY_COOKIE } from '~/constants/localization';
import { getCountryByCode, getCountryLabelByCode, getDefaultCountryByLocale } from '~/utils/localization';

// Local types

// --------------- LOCALIZATION ---------------//

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalLocalizationChoiceOrganism',
  setup: function setup(__props, _ref) {
    var _azClientCountryCooki;
    var expose = _ref.expose;
    // Libs
    var _useLocaleSwitcher = useLocaleSwitcher(),
      handleLoadingUpdate = _useLocaleSwitcher.handleLoadingUpdate,
      selectLocale = _useLocaleSwitcher.selectLocale,
      updateLocalization = _useLocaleSwitcher.updateLocalization,
      resetUrlToDefault = _useLocaleSwitcher.resetUrlToDefault,
      isLocalizationUpdating = _useLocaleSwitcher.isLocalizationUpdating,
      localizedUrl = _useLocaleSwitcher.localizedUrl;

    // ----------------GLOBALS-------------------- //
    var COOKIE_MAX_AGE = 6 * 30 * 24 * 60 * 60; // 6 months (approximately)
    var modalScenario = ref('standard');
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      ctConfig = _useNuxt2App.$vsf.$ct.config;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var hasLocaleOrCountryChanged = ref(false);
    var modalRef = ref(null);
    var localeModalOpened = useCookie('country-modal-opened', {
      watch: 'shallow',
      maxAge: COOKIE_MAX_AGE
    });
    var azClientCountryCookie = useCookie(AZ_COUNTRY_COOKIE);
    var _useI18nLocale = useI18nLocale(),
      getCurrentLocale = _useI18nLocale.getCurrentLocale;
    function closeModal() {
      if (!isLocalizationUpdating.value) {
        modalRef.value.modal.close();
      }
    }

    // ----------------COUNTRY-------------------- //
    var _useLocalization2 = useLocalization(),
      locale = _useLocalization2.locale;
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country,
      setCountryCode = _useShippingCountry.setCountryCode,
      availableCountries = _useShippingCountry.availableCountries;
    var chosenCountry = ref(getCountryByCode(currentCountry.value));
    var azClientCountry = ref((_azClientCountryCooki = azClientCountryCookie.value) !== null && _azClientCountryCooki !== void 0 ? _azClientCountryCooki : getDefaultCountryByLocale(locale));
    var deliveryCountryByIpLabel = computed(function () {
      return getCountryLabelByCode(azClientCountry.value);
    });
    function setCurrentCountry(country) {
      setCountryCode(country.name);
      hasLocaleOrCountryChanged.value = true;
    }
    function filterBy(_, label, search) {
      return (label || '').toLocaleLowerCase().charAt(0).includes(search.toLowerCase().charAt(0));
    }
    function checkDeliveryCountryMismatch() {
      var countryMismatch = azClientCountry.value !== country;
      return !localeModalOpened.value && countryMismatch;
    }

    // ----------------LOCALE-------------------- //
    var chosenLocale = ref(getCurrentLocale());
    var availableLanguagesDisplayed = computed(function () {
      return ctConfig.locales.map(function (locale) {
        return {
          code: locale.name,
          label: locale.label
        };
      }).sort(function (a, b) {
        return a.code > b.code ? 1 : -1;
      });
    });
    function setCurrentLocale(locale) {
      chosenLocale.value = locale;
      hasLocaleOrCountryChanged.value = true;
      selectLocale(chosenLocale.value);
    }
    var localeErrorMessage = computed(function () {
      if (localizedUrl.value === '/' && !route.name.includes('index') && !isLocalizationUpdating.value) {
        return i18n.t('modals.locale-choice.text.translationNotAvailable');
      }
      return '';
    });

    // ------------CONFIRM ACTIONS------------- //
    var _useLocalization3 = useLocalization(),
      currentCurrency = _useLocalization3.currency;
    function confirmChoices() {
      if (hasLocaleOrCountryChanged.value) {
        gtmPushEvent('change_language', {
          event: 'generic_event',
          event_category: 'engagement',
          event_action: 'change',
          event_label: 'language',
          event_name: 'change_language',
          country: chosenCountry.value.name,
          currency: currentCurrency,
          language: chosenLocale.value
        });
        handleLoadingUpdate(true);
        updateLocalization(chosenCountry.value.name, chosenLocale.value);
        if (modalScenario.value === 'auto-suggest') {
          localeModalOpened.value = 'true';
        }
        return;
      }
      closeModal();
    }

    // ------------UTILS------------- //
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    function handleCloseEvent() {
      chosenCountry.value = getCountryByCode(currentCountry.value);
      chosenLocale.value = getCurrentLocale();
      resetUrlToDefault();
      if (modalScenario.value === 'auto-suggest') {
        modalScenario.value = 'standard';
        localeModalOpened.value = 'true';
      }
    }

    // ------------LIFECYCLE------------- //
    onMounted(function () {
      var isDeliveryCountryMismatch = checkDeliveryCountryMismatch();
      if (!isDeliveryCountryMismatch) {
        return;
      }
      modalScenario.value = 'auto-suggest';
      modalRef.value.modal.showModal();
      gtmPushEvent('store_switcher_modal_opened', {
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'change',
        event_label: 'store_switcher_modal_opened',
        event_name: 'store_switcher_modal_opened',
        country: currentCountry.value,
        azClientCountry: azClientCountry.value,
        currency: currentCurrency,
        language: chosenLocale.value,
        trigger: 'country-mismatch'
      });
      if (azClientCountry.value && azClientCountry.value !== currentCountry.value) {
        chosenCountry.value = getCountryByCode(azClientCountry.value);
        hasLocaleOrCountryChanged.value = true;
      }
    });
    expose({
      modalRef: modalRef
    });
    return {
      __sfc: true,
      handleLoadingUpdate: handleLoadingUpdate,
      selectLocale: selectLocale,
      updateLocalization: updateLocalization,
      resetUrlToDefault: resetUrlToDefault,
      isLocalizationUpdating: isLocalizationUpdating,
      localizedUrl: localizedUrl,
      COOKIE_MAX_AGE: COOKIE_MAX_AGE,
      modalScenario: modalScenario,
      route: route,
      i18n: i18n,
      ctConfig: ctConfig,
      country: country,
      hasLocaleOrCountryChanged: hasLocaleOrCountryChanged,
      modalRef: modalRef,
      localeModalOpened: localeModalOpened,
      azClientCountryCookie: azClientCountryCookie,
      getCurrentLocale: getCurrentLocale,
      closeModal: closeModal,
      locale: locale,
      currentCountry: currentCountry,
      setCountryCode: setCountryCode,
      availableCountries: availableCountries,
      chosenCountry: chosenCountry,
      azClientCountry: azClientCountry,
      deliveryCountryByIpLabel: deliveryCountryByIpLabel,
      setCurrentCountry: setCurrentCountry,
      filterBy: filterBy,
      checkDeliveryCountryMismatch: checkDeliveryCountryMismatch,
      chosenLocale: chosenLocale,
      availableLanguagesDisplayed: availableLanguagesDisplayed,
      setCurrentLocale: setCurrentLocale,
      localeErrorMessage: localeErrorMessage,
      currentCurrency: currentCurrency,
      confirmChoices: confirmChoices,
      isMobile: isMobile,
      handleCloseEvent: handleCloseEvent,
      VSelect: VSelect,
      AzButton: AzButton,
      AzLoader: AzLoader,
      AzModal: AzModal,
      LocaleIcon: LocaleIcon,
      InformationBox: InformationBox,
      InformationItem: InformationItem,
      AzIcon: AzIcon
    };
  }
});